/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var Constants = require('../../../../../utils/Constants');
var RadioMixin = require('ES/utils/RadioMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');

var StoredFileModal = require('./StoredFileModal');

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState: function(){
		return {file_id_editing: null, deleting: -1, file_id_confirming_delete: -1, error_msg: null};
	},
	componentWillMount: function(){
		var self = this;
		self.radio = {
			StoredFile_remove: function(eid, fileid){
				if(eid === (self.props.event && self.props.event.eid)){
					self.setState({deleting: fileid, file_id_confirming_delete: -1, error_msg: null});
				}
			},
			StoredFile_remove_succeeded: function(eid, fileid, storedfiles){
				if(eid === (self.props.event && self.props.event.eid)){
					self.setState({deleting: -1, file_id_confirming_delete: -1, error_msg: null});
				}
			},
			StoredFile_remove_failed: function(eid, fileid, message){
				if(eid === (self.props.event && self.props.event.eid)){
					self.setState({deleting: -1, file_id_confirming_delete: -1, error_msg: 'Failed to delete: ' + message});
				}
			}
		};
	},
	__clickDelete: function(id){
		var self = this;
		return esUtils.wrapPreventDefault(function(){
			self.setState({file_id_confirming_delete: id});
		});
	},
	__deleteFile: function(id){
		var self = this;
		return esUtils.wrapPreventDefault(function(){
			radio('StoredFile_remove').broadcast(self.props.event.eid, id);
		});
	},
	__downloadURL: function(url){
		return esUtils.wrapPreventDefault(function(){
			window.open(url);
		});
	},
	__setEditingId: function(id){
		var self = this;
		return esUtils.wrapPreventDefault(function(){
			self.setState({file_id_editing: id});
		});
	},
	render: function(){
		var event = this.props.event;
		var deleting = this.state.deleting;
		var error_msg = this.state.error_msg;
		var file_id_confirming_delete = this.state.file_id_confirming_delete;

		return dd.div(null,
			dd.h4({className: 'section-head'}, 'Attached Files'),
			ErrorAlert({message: error_msg}),
			LoadingWrap({is_loading: deleting > 0, glass: true},
				dd.table({className: 'table table-responsive table-condensed table-hover FilesList', style: {marginBottom: 10}},
					dd.thead(null,
						dd.tr(null,
							dd.th(null, 'File'),
							dd.th({style: {width: 1}}, 'Posted'),
							dd.th({style: {width: '1.5em'}}),
							dd.th({style: {width: '1.5em'}})
						)
					),
					dd.tbody(null,
						_.map(event.storedfiles, function(file, i){
							var confirm_delete = file.id === file_id_confirming_delete;
							var is_deleting = file.id === deleting;
							return dd.tr({key: i, className: 'file clickable'},
								dd.td({onClick: this.__downloadURL(file.url)},
									dd.i({className: 'file-icon fa ' + Constants.getFileTypeIcon(file.url)}),
									file.description
								),
								confirm_delete || is_deleting ? null : dd.td({onClick: this.__downloadURL(file.url)}, esUtils.format_date(file.postdate, 'mm/dd/yyyy')),
								confirm_delete || is_deleting ? null : dd.td(null, dd.a({href: '#', onClick: this.__setEditingId(file.id)}, dd.i({className: 'fa fa-pencil'}))),
								confirm_delete || is_deleting ? null : dd.td(null, dd.a({href: '#', onClick: this.__clickDelete(file.id)}, dd.i({className: 'fa fa-times'}))),
								confirm_delete || is_deleting ? dd.td({colSpan: 3},
									confirm_delete ? dd.div({className: 'btn-group'},
										dd.button({className: 'btn btn-danger btn-sm', onClick: this.__deleteFile(file.id)}, 'Delete'),
										dd.button({className: 'btn btn-default btn-sm', onClick: this.__clickDelete(-1)}, 'No')
									) : null,
									is_deleting ? 'Deleting....' : null
								) : null
							);
						}, this),
						!_.isArray(event.storedfiles) || event.storedfiles.length === 0 ? dd.tr(null,
							dd.td({colSpan: 4},
								dd.div({className: 'text-center emptylist'},
									'Attach files for this event (contract, spreadsheets, etc.) by clicking ATTACH FILE.'
								)
							)
						) : null
					)
				),
				dd.div(null,
					dd.button({className: 'btn btn-default btn-sm pull-right', onClick: this.__setEditingId(0)}, dd.i({className: 'fa fa-paperclip'}), ' Attach File'),
					dd.div({className: 'clearfix'})
				)
			),
			this.state.file_id_editing !== null ? StoredFileModal({
				event: event,
				file_id: this.state.file_id_editing,
				onClose: this.__setEditingId(null)
			}) : null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/library/AttachedFiles.js